"use client";
import styled from "@emotion/styled";


export const MainWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-width: 1600px;
  label: MainWrapper;
`;

export const Version = styled.span`
  position: absolute;
  width: 100%;
  bottom: 4px;
  left: 0;
  font-size: 10px;
  text-align: center;
  opacity: 0.3;
  color: #fff;
`;
